import { render } from "./ExpedientDetailChangeMediaName.vue?vue&type=template&id=ea0e8b50"
import script from "./ExpedientDetailChangeMediaName.vue?vue&type=script&lang=js"
export * from "./ExpedientDetailChangeMediaName.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__